<template>
<div>
	<wrapper-edit
      :wrapper-width="wrapperWidth"
      @back="paasPageBack">
    <Form ref="paasForm" slot="form"
            :model="paasFormData"
            :rules="paasFormRules"
            :label-width="defaultLabelWidth">
       <Row>
         <FormItem label="文章标题：" prop="name" class="ivu-col-span-24" >
          <Input v-model="paasFormData.name"
                      clearable ></Input>
          </FormItem>
       </Row>
       <Row>
       <FormItem label="文章作者：" prop="author" class="ivu-col-span-24" >
        <Input v-model="paasFormData.author"
                    clearable ></Input>
	      </FormItem>
       </Row>
       <Row>
       <FormItem label="分类：" prop="cid" class="ivu-col-span-24" v-clickoutside="handlecidClose">
		     <Input v-model="paasFormData.ctitle" @on-focus="changecidFlag" @on-clear="clearcid" clearable  readonly="readonly"></Input>
         <select-tree @selected-tree-value="updatecidTreeNode"  serviceUrl='/eb/article/category' v-if="showcidTree" />
	     </FormItem>
       </Row>
      <Row>
        <FormItem label="封面大图(900像素 * 500像素):"  class="ivu-col-span-24">
          <div class="file-upload-list" v-if="paasFormData.imageInput">
            <template>
              <img :src="paasFormData.imageInput">
              <div class="file-upload-list-cover">
                <Icon type="ios-eye-outline" @click.native="handleView(paasFormData.imageInput)"></Icon>
                <Icon type="ios-trash-outline" @click.native="handleRemove(paasFormData.deleteUrl)"></Icon>
              </div>
            </template>
          </div>
          <div class="fc-upload-btn" ref="uploadBtn" @click="openUploadPanel"
               v-if="!paasFormData.imageInput && paasFormData.imageInput === ''">
            <Icon type="md-camera" size="20"/>
          </div>
        </FormItem>
      </Row>
       <Row>
          <FormItem label="文章简介：" prop="synopsis" class="ivu-col-span-24" >
            <Input v-model="paasFormData.synopsis"
                type="textarea"  clearable ></Input>
	        </FormItem>
       </Row>
      <Row>
        <FormItem label="文章内容：" prop="content" class="ivu-col-span-24" >
          <div ref="ueditorWrap">
            <vue-ueditor-wrap v-model="paasFormData.content"
                              :config="myConfig" ref="ueditor"></vue-ueditor-wrap>
          </div>
        </FormItem>
      </Row>
       <Row>
          <FormItem label="是否轮播图(小程序)：" prop="isBanner" class="ivu-col-span-12" >
			      <Enum :enumJsonKey="'crmdict-yesOrNo'"  v-model="paasFormData.isBanner"  type="radio" ></Enum>
		      </FormItem>
          <FormItem label="是否热门(小程序)：" prop="isHot" class="ivu-col-span-12" >
			      <Enum :enumJsonKey="'crmdict-yesOrNo'"  v-model="paasFormData.isHot"  type="radio" ></Enum>
		      </FormItem>
       </Row>
       <Row>
        <FormItem label="原文链接：" prop="url" class="ivu-col-span-24" >
          <Input v-model="paasFormData.url"
                 clearable ></Input>
        </FormItem>
       </Row>
       <div class="edit-oper-toolbar">
	      <Button type="primary" @click="paasFormSubmit('paasForm','','add')">保存并继续添加</Button>
	      <Button @click="paasFormSubmit('paasForm','','articleList')" style="margin-left: 8px">保存并返回</Button>
	      <Button @click="paasPageBack" style="margin-left: 8px">返回</Button>
	    </div>
      <FileModal id="fileModal"
                 @save-file="saveFileData"
                 thumbnailWidth="180"
                 thumbnailHeight="100"
                 :uploadParams="uploadParams"
                 :uploadAction="uploadAction"
                 @on-close="hiddenModal"
                 v-if="uploadModal"
                 class="paas-file-select" ></FileModal>
      <Modal title="图片预览" v-model="visible">
        <img :src="paasFormData.image" v-if="visible" style="width: 100%">
      </Modal>
    </Form>
    </wrapper-edit>
</div>
</template>
<script>
import wrapperEdit from "@/components/paas/wrapper-edit";
import metaEdit from "@/assets/js/meta-edit.js";
import Enum from '@/components/paas/enum-form' //枚举渲染
import SelectTree from '@/components/paas/selectTree'; //下拉树
import VueUeditorWrap from 'vue-ueditor-wrap';
import FileModal from '@views/sys/image/select'
 
export default {
   name: "edit",
   mixins:[metaEdit],
   components:{wrapperEdit,Enum,SelectTree,VueUeditorWrap,FileModal},
   data(){
     return {
     	serviceUrl:"/eb/article",  //每个页面访问后台服务器的路径
      	currentIdFiledName: 'id',
        paasFormData:{
        	id:'',
        	shareTitle:'',
        	sort:'',
        	imageInput:'',
        	url:'',
        	visit:'',
        	isHot:'',
        	status:'',
        	cid:'',
            ctitle:'',
        	author:'',
        	shareSynopsis:'',
        	synopsis:'',
        	isBanner:'',
        	addTime:'',
        	merId:'',
        	adminId:'',
        	name:'',
        	hide:'',
        	content:'',
            deleteUrl:'',
            fileData:'',
            width:'180',
            height:'100',
            paasRepeatSubmitFlag:'',
        },
        paasFormRules:{
        },
		    /**
       	* 下拉树
       	* */
      	showcidTree:false, 			
        redirectName:"articleList",
        nextAddName:"articleEdit",
        defaultLabelWidth:150,
        myConfig: {
           autoHeightEnabled: false,// 编辑器不自动被内容撑高,默认true
           initialFrameHeight: "800",//初始化编辑器高度,默认320
           initialFrameWidth: '100%',
           //initialFrameWidth: '350',  //初始化编辑器宽度,默认1000
           // UEditor 资源文件的存放路径，如果你使用的是 vue-cli 生成的项目，通常不需要设置该选项，vue-ueditor-wrap 会自动处理常见的情况，如果需要特殊配置，参考下方的常见问题2
           UEDITOR_HOME_URL: '/UE/',
           initialContent: '请输入内容',
           autoClearinitialContent: true, //是否自动清除编辑器初始内容，注意：如果focus属性设置为true,这个也为真，那么编辑器一上来就会触发导致初始化的内容看不到了
           // 工具栏是否可以浮动
           autoFloatEnabled: false,
           //serverUrl: "http://127.0.0.1:66/ueditor/ueditorConfig"
          serverUrl: "https://wx.api.gymthy.com/ueditor/ueditorConfig"
        },
        fileList:[],
        uploadParams: {
         fileBusinessType: 'article',
         fileBusinessProp: 'photo',
         fileBusinessId: '',
        },
       uploadModal:false,
       visible:false,
     }
   },
   computed:{
    uploadAction(){
      return this.$store.state.sysApi+'/sys/file/uploadAttacheSlice';
    }
   },
   methods:{
     /**
      * 保存前逻辑
      */
     paasFormSubmitBefore(){
       this.paasFormData.fileData = JSON.stringify(this.fileList);
     },
     handleView () {
       this.visible = true;
     },
     handleRemove (deleteUrl) {
      // ;
       if(deleteUrl && typeof(deleteUrl) !=="undefined"){
         this.axios.post(deleteUrl).then(res => {
           if(res.code === 200){
             this.paasFormData.imageInput = "";
             this.$Message.success("附件删除成功");
           }
         }).catch(err =>{
           this.$Message.error('附件删除失败，请重试！');
         });
       }else{
         this.paasFormData.imageInput = "";
       }
     },
     /**
      * 进入edit后的逻辑
      * */
     createdCallback(data) {
       this.paasFormData.imageInput = data.entity.picFile.showUrl;
       this.paasFormData.deleteUrl = data.entity.picFile.deleteUrl;
       this.uploadParams.fileBusinessId = data.paasRepeatSubmitFlag;
     },
     /**
      * 打开附件弹出框
      */
     openUploadPanel(){
       this.uploadModal = true;
       //计算当前位置的top以及left
       let top = this.$refs.uploadBtn.getBoundingClientRect().top;
       this.$nextTick(()=>{
         document.getElementById("fileModal").style.top = top+"px";
         document.getElementById("fileModal").style.left = 0;
       });
     },
     /**
      * 隐藏附件弹出框
      */
     hiddenModal(){
       this.uploadModal = false;
     },
	   /**
	    * 显示节点下拉树
	    */
	    changecidFlag(){
	      this.showcidTree = true;
	    },
	    updatecidTreeNode(node){
	      this.paasFormData.cid = node.id;
	      this.paasFormData.ctitle = node.title;
	      this.showcidTree = false;
	    },
	    handlecidClose(){
	      this.showcidTree = false;
	    },
       /**
       * 清除后查询
       */
      clearcid(){
        this.paasFormData.id = "";
      },
     /**
      * 选中附件后的操作
      * @param files
      */
     saveFileData(files){
      this.paasFormData.imageInput = files[0].showUrl;
      if(files[0].showUrl == null)  this.paasFormData.imageInput = files[0].thumbnailUrl;
       this.paasFormData.deleteUrl = "";
       this.fileList = files;
       this.hiddenModal();
     },
  }
}
</script>
<style scope>
  @import "../../../assets/css/file/file-upload.css";
</style>
